export interface Theme {
  name: string;
  properties: any;
}

export const light: Theme = {
  name: 'light',
  properties: {
    '--background-default': '#ffffff',
    '--background-secondary': '#e6e6e6',
    '--background-tertiary': '#5C7D99',
    '--background-light': '#f7f9fc',

    '--button-default': '#1742FF',
    '--button-secondary': '#1890ff',
    '--button-dark': '#34C759',
    '--button-light': '#eff2ff',

    '--error-default': '#EF3E36',
    '--error-dark': '#800600',
    '--error-light': '#FFCECC',

    '--text-default': '#333333',
    '--text-secondary': '#3366fb',
    '--text-dark': '#000000',
    '--text-light': '#ececec',
    '--text-selected': '#3366fb',
    '--text-choosed' : '#ffffff',

    '--radio-ripple-primary': '#3d6cf88a',
    '--sidebar-a-hover': '#23527c',
    '--sidenav-toggler': '#1741ff',

    '--hover': '#1742FF1A',
    '--hover-shadow': '#1742FF40',
  },
};

export const dark: Theme = {
  name: 'dark',
  properties: {
    '--background-default': '#393939',
    '--background-secondary': '#e6e6e6',
    '--background-tertiary': '#08090A',
    '--background-light': '#f7f9fc',

    '--button-default': '#333333',
    '--button-secondary': '#8c8c8c',
    '--button-dark': '#393939',
    '--button-light': '#616161',

    '--error-default': '#EF3E36',
    '--error-dark': '#800600',
    '--error-light': '#FFCECC',

    '--text-default': '#FFFFFF',
    '--text-secondary': '#3366fb',
    '--text-dark': '#000000',
    '--text-light': '#999999',
    '--text-selected': '#ffffff',
    '--text-choosed' : '#333333',

    '--radio-ripple-primary': '#2b2c2c8a',
    '--sidebar-a-hover': '#bababa',
    '--sidenav-toggler': '#777777',

    '--hover': '#F2F2F2',
    '--hover-shadow': '#33333340',
  },
};
